import { createFileRoute, Link, useRouter } from '@tanstack/react-router'
import { Page } from '@/components/layout/page'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/')({
  component: ClientList,
})

/** Native shell opens /<client> directly; this list is for development. */
function ClientList() {
  const router = useRouter()
  const clients = Object.keys(router.routesByPath).filter(
    (p) => /^\/[^/]+$/.test(p) && p !== '/dev' && p !== '/settings',
  )

  return (
    <Page title="Clients" className="space-y-2 p-4">
      {clients.map((path) => (
        <Button key={path} variant="outline" className="w-full justify-start" asChild>
          <Link to={path}>{path.slice(1)}</Link>
        </Button>
      ))}
      <Button variant="ghost" className="w-full justify-start" asChild>
        <Link to="/settings">Webview settings</Link>
      </Button>
    </Page>
  )
}
